/**
 * Tipos do funil ao vivo que a tela lê (fora do contrato: a demonstração não os tem). Arquivo leve,
 * sem as fontes reais, para o chunk do Funil não carregar o modo ao vivo à toa.
 */
import type { ChannelRow, FunnelStageIdV2, FunnelV2Report } from '@rota/contracts';

/** Por que uma etapa do funil não tem número (a dica do "Não medido" na tela). */
export type NotMeasuredReason =
  | 'no_tracker'
  | 'cta_event'
  | 'checkout_event'
  | 'vturb_channel'
  | 'vturb_off'
  | 'vturb_error'
  | 'organic_no_media'
  | 'meta_off'
  | 'manual';

/**
 * Linha da tabela de canais ao vivo: plays e consultorias por canal não são medidos (null = "—"); o
 * gasto dos Anúncios fica null sem a leitura real da Meta (nunca R$ 0).
 */
export type LiveChannelRow = Omit<ChannelRow, 'vslPlays' | 'backendClosed' | 'spend'> & {
  vslPlays: number | null;
  backendClosed: number | null;
  spend: number | null;
};

/** O que o relatório do funil ao vivo traz a mais (fora do contrato; a demonstração não tem). */
export interface LiveFunnelExtras {
  /** Calculado com os dados reais (modo ao vivo). */
  live: true;
  /** Vendas de anúncio pela Meta (Gerenciador) no recorte; null sem a Meta (ou servidor antigo). */
  adsMeta: { purchases: number; valueCents: number } | null;
  /** Motivo de cada etapa sem número. */
  notMeasured: Partial<Record<FunnelStageIdV2, NotMeasuredReason>>;
  /** As consultorias de R$ 100 mil ainda não são registradas: etapas e colunas da consultoria saem. */
  backendMeasured: false;
  /** Vendas do curso sem origem (sem UTM) no recorte: entram só em Todos. */
  noOrigin: number;
}

export type LiveFunnelV2Report = FunnelV2Report & LiveFunnelExtras;

/** O relatório veio do modo ao vivo? Devolve os campos a mais, ou null (demonstração). */
export function liveExtras(r: FunnelV2Report | null | undefined): LiveFunnelExtras | null {
  return r && (r as Partial<LiveFunnelExtras>).live === true ? (r as LiveFunnelV2Report) : null;
}
